
import * as z from "zod";

// Create a function that builds the schema to handle potential Zod limitations
export const createProfileFormSchema = () => {
  try {
    // Try to create the schema using Zod's API
    return z.object({
      display_username: z.string().optional(),
      university: z.string().optional(),
      university_id: z.string().optional(),
      lab: z.string().optional(),
      lab_id: z.string().optional(),
      city: z.string().optional(),
      country: z.string().optional(),
      research_interests: z.string().optional(),
      expertise: z.string().optional(),
      linkedin_url: z.string().url("Please enter a valid URL").nullish(),
      website_url: z.string().url("Please enter a valid URL").nullish(),
      email: z.string().email("Please enter a valid email address"),
      newPassword: z.string()
        .min(6, "Password must be at least 6 characters")
        .optional()
        .or(z.literal('')),
      confirmPassword: z.string().optional().or(z.literal('')),
      email_notifications: z.boolean(),
      notify_swap_offers: z.boolean(),
      notify_swap_responses: z.boolean(),
      daily_digest_email: z.boolean(),
      notify_messages: z.boolean(),
      weekly_digest_email: z.boolean(),
    }).refine(
      (data) => !data.newPassword || data.newPassword === data.confirmPassword,
      {
        message: "Passwords do not match",
        path: ["confirmPassword"],
      }
    );
  } catch (error) {
    console.error("Error creating Zod schema:", error);
    // If Zod fails, return a basic object that will be handled by the fallback validator
    return {} as any;
  }
};
